import {
  ArrowLeftOutline,
  ArrowRightOutline,
  BellOutline,
  BookOutline,
  CheckCircleOutline,
  CloseOutline,
  DownOutline,
  ExclamationCircleOutline,
  FileOutline,
  FileTextOutline,
  KeyOutline,
  MehOutline,
  MenuOutline,
  PlusOutline,
  ProfileOutline,
  RightOutline,
  SendOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  StopOutline,
  UploadOutline,
  UserOutline,
  GiftOutline,
  CloseSquareOutline,
} from '@ant-design/icons-angular/icons';

export const icons = [
  BellOutline,
  SendOutline,
  CheckCircleOutline,
  MenuOutline,
  RightOutline,
  PlusOutline,
  BookOutline,
  UploadOutline,
  CloseOutline,
  ProfileOutline,
  MehOutline,
  FileOutline,
  DownOutline,
  ExclamationCircleOutline,
  ShareAltOutline,
  KeyOutline,
  SettingOutline,
  UserOutline,
  FileTextOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  StopOutline,
  ShoppingCartOutline,
  GiftOutline,
  CloseSquareOutline
];
